import intl from 'react-intl-universal';
import { useEffect, useState } from 'react';

import { DynamicForm, Modal } from '@/components';
import { ProFormColumnsType } from '@ant-design/pro-components';
import { getIvrs } from '@/api/softPhone';

interface Props {
    show: boolean;
    onSave?: (params) => void;
    onClose?: () => void;
}

// i18n-ignore
const ivrName = '转接队列';

// import style from '../index.less';
const ChangeQueue: React.FC<Props> = ({ show = false, onSave, onClose }) => {
    const [queueList, setQueueList] = useState([]);

    useEffect(() => {
        if (show) {
            getIvrs(ivrName).then((res) => {
                console.log('-=-=-=', res);
                setQueueList(
                    res.data?.map((item) => {
                        return {
                            label: item.name,
                            value: item.endpoint,
                        };
                    }),
                );
            });
        }
    }, [show]);

    const columns: ProFormColumnsType[] = [
        {
            dataIndex: 'ivrNode',
            title: intl.get('队列'),
            valueType: 'select',

            fieldProps: {
                options: queueList,
            },
            formItemProps: {
                rules: [
                    {
                        required: true,
                        message: intl.get('请选择队列'),
                    },
                ],
            },
        },
    ];

    const onFinish = async (values) => {
        console.log(values);
        onSave?.({
            ...values,
            ivrName,
        });
    };

    return (
        <Modal
            title={intl.get('转队列')}
            open={show}
            // onOk={handleOk}
            onCancel={onClose}
            footer={null}
            destroyOnClose={true}
        >
            <DynamicForm
                className="modalForm"
                labelCol={{ span: 6 }}
                columns={columns}
                onFinish={onFinish}
                initialValues={{
                    bindType: 2,
                    loginStatus: 1,
                }}
                submitter={{
                    searchConfig: {
                        resetText: intl.get('取消'),
                        submitText: intl.get('确认'),
                    },
                    onReset: () => {
                        onClose?.();
                    },
                }}
            />
        </Modal>
    );
};

export default ChangeQueue;
